import makeStyles from '@mui/styles/makeStyles';

type NavigationStyleProp = {
  disablePrevious?: boolean;
  disableNext?: boolean;
};

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    maxWidth: '70%',
    marginTop: theme.spacing(0.25)
  },
  period: {
    fontSize: '1.05rem',
    fontWeight: theme.typography.fontWeightMedium,
    display: 'flex',
    alignItems: 'center'
  }
}));

export const usePreviousNavigationStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(-0.5),
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.h5.fontWeight,
    color: ({ disablePrevious }: NavigationStyleProp) =>
      disablePrevious ? theme.palette.grey[500] : theme.palette.common.black
  }
}));

export const useNextNavigationStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(-0.5),
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.h5.fontWeight,
    color: ({ disableNext }: NavigationStyleProp) =>
      disableNext ? theme.palette.grey[500] : theme.palette.common.black
  }
}));
